import { render, staticRenderFns } from "./ProductThumbnail.vue?vue&type=template&id=4295f742&scoped=true"
import script from "./ProductThumbnail.vue?vue&type=script&lang=js"
export * from "./ProductThumbnail.vue?vue&type=script&lang=js"
import style0 from "./ProductThumbnail.vue?vue&type=style&index=0&id=4295f742&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4295f742",
  null
  
)

export default component.exports